import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { ConsultaExtratoPreviModel } from '../../../../models/consulta-extrato-previ.model';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class FPCReservaPreviPdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _formateNumberZeroPipe: FormateNumberZeroPipe,
    private _cpf: CpfPipe
  ) { }

  public funcionarios(pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, consultaExtratoPreviModel: Array<ConsultaExtratoPreviModel>) {

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 30, 20);
    doc.setFontSize(13);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`Consulta Fração Patrimonial`, 75, 50)

    doc.autoTable({
      startY: 60
    })

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
        halign: 'left'
      },
      head: [[
        `Observações:
        \n\n
      1) O Convênio que trata da reserva matemática da PREVI, relativamente aos ex-funcionários do Banco do
      Brasil optantes pelo quadro de pessoal do Banco Central do Brasil, firmado entre o Banco do Brasil S.A.,
      a Caixa de Previdéncia dos Funcionários do Banco do Brasil - PREVI, o Banco Central do Brasil e a
      Fundação Banco Central de Previdéncia Privada - CENTRUS, foi celebrado em 23/12/1997;
      \n
      2) As reservas matemáticas da PREVI foram apuradas considerando a data base de 06.09.1996, e
      incorporadas a fração patrimonial da CENTRUS em janeiro de 1998;
      \n
      3) No período compreendido entre a apuração e a incorporação, o valor da reserva da PREVI foi atualizado
      com base no IGP-DI acrescido de juros de 6% a.a.;
      \n
      4) Após a incorporação os valores lançados em fração patrimonial vêm sendo remunerados tendo por base o
      índice de rentabilidade patrimonial apurado mensalmente pela CENTRUS.
      `]],
    });




    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      columnStyles: {
        0: { cellWidth: 30 }
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome]],
    });



    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 10,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      styles: {
        fontSize: 8,
        halign: 'center'
      },
      head: this._headRows(),
      body: this._bodyRows(consultaExtratoPreviModel)
    });


    doc.setProperties({
      title: 'FPDC - Consulta',
      subject: `FPC - Consulta Fração Patrimonial `,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
      ? (window.open(URL.createObjectURL(doc.output('blob'))))
      : this.handleFile(doc.output('blob'), 'fpd-reserva.pdf');
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }



    const blob = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;

    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    setTimeout(() => { // firefox
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }

  private _bodyRows(consultaExtratoPreviModel: Array<ConsultaExtratoPreviModel>) {
    const body = []

    consultaExtratoPreviModel.map(item => {
      body.push({
        dtReferencia: item.dtRef,
        dsReferencia: item.sgHistorico,
        vlOcorrencia: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlLancto	, '1.1-2')),
        vlSaldo: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlSaldo	, '1.1-2'))
      })
    })
    return body;
  }

  private _headRows() {
    return [{
      dtReferencia: 'Data',
      dsReferencia: 'Histórico',
      vlOcorrencia: 'Valor',
      vlSaldo: 'Saldo'
    },
    ]
  }






}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/Plano/fpc/fpc-reserva-previ-pdf.ts